import React from "react"
import styled from "styled-components"
import "./style.scss"
import { Text, Image } from "./styled-compnent"
import { HelpInfo } from "src/components/help-center-section"
import { useHistory } from "react-router"
import { images } from "src/assets"

export const GridContainer = styled.div<any>`
  display: flex;
  margin-bottom: 40px;
  width: ${props => (props.width ? props.width : "100%")};
  @media (max-width: 900px) {
    width: 100%;
  }
`

export const ArticleCard = styled.div<any>`
  display: flex;
  box-shadow: -1px 3px 6px #00000029;
  padding: 1rem;
  align-items: center;
  border-radius: 4px;
  background: #fff;
  width: 100%;
  cursor: pointer;
`

type Props = {
  width?: string
  color: string
  title: string
  id: string
  index: number
  count: string
}
export const Icons = [
  images.GettingStartIcon,
  images.AdministrationIcon,
  images.CompliantIcon,
  images.PolicyIcon,
  images.ServiceIocn,
  images.TipsIocn
]

const HelpGrid = (props: Props) => {
  const { width = "100%", color = "", title = "", count = "", id, index } = props
  const history = useHistory()

  const gotoCollection = (id: string, title: string) => {
    history.push({
      pathname: `/help-center/collection/${id}`,
      state: {
        title: title,
        Icons: Icons[index]
      }
    })
  }

  return (
    <>
      <GridContainer width={width} onClick={() => gotoCollection(id, title)} key={id}>
        <ArticleCard>
          <Image
            width={"35px"}
            height={"35px"}
            alt=""
            src={Icons[index] || Icons[Math.floor(Math.random() * Icons.length)]}
          />
          <div>
            <Text fontSize={19} fontWeight={300} color={color}>
              {title}
            </Text>
            <HelpInfo title={`${count ? count : 0} articles in this collection`} />
          </div>
        </ArticleCard>
      </GridContainer>
    </>
  )
}

export default HelpGrid
